var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlineCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5006 13.5375C15.8898 12.9221 14.4105 12.0241 13.6928 11.6622C12.7582 11.1914 12.6813 11.153 11.9466 11.6987C11.4566 12.0629 11.1309 12.3883 10.5574 12.266C9.9839 12.1437 8.73772 11.4541 7.64654 10.3665C6.55536 9.27881 5.82572 7.99656 5.70303 7.42504C5.58033 6.85353 5.91111 6.53162 6.27189 6.04049C6.78036 5.34821 6.7419 5.23283 6.30727 4.29825C5.96842 3.57136 5.04416 2.10604 4.42646 1.49837C3.76567 0.845711 3.76567 0.96109 3.33989 1.13801C2.99326 1.28384 2.66071 1.46111 2.34641 1.6676C1.73101 2.07643 1.38946 2.41603 1.15061 2.92639C0.911756 3.43675 0.804446 4.63324 2.03794 6.87391C3.27143 9.11459 4.13683 10.2603 5.92803 12.0464C7.71923 13.8325 9.09657 14.7928 11.1101 15.922C13.6009 17.3169 14.5563 17.045 15.0683 16.8066C15.5802 16.5681 15.9214 16.2297 16.331 15.6143C16.538 15.3006 16.7157 14.9684 16.8618 14.622C17.0391 14.1978 17.1545 14.1978 16.5006 13.5375Z",
    stroke: "#AD2F3B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineCall);
export default __webpack_public_path__ + "static/media/outlineCall.3e3d92828938f55a261cc58746a7ddf9.svg";
export { ForwardRef as ReactComponent };